// トップスライダーの起動 // Launch the top slider

const swiper = new Swiper(".top-swiper", {
  speed: 1000, // スライド変化時間
  loop: true,
  loopAdditionalSlides: 1,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 4000, //　スライダー表示時間
    disableOnInteraction: false,
  },

});
